import { render, staticRenderFns } from "./sheetCaracteristics.vue?vue&type=template&id=38dc182c&scoped=true"
import script from "./sheetCaracteristics.vue?vue&type=script&lang=js"
export * from "./sheetCaracteristics.vue?vue&type=script&lang=js"
import style0 from "./sheetCaracteristics.vue?vue&type=style&index=0&id=38dc182c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dc182c",
  null
  
)

export default component.exports